import React, { useEffect, useState } from "react";
import API from "../services/api";
import Sidebar from "../components/Sidebar";
import DashboardCards from "../components/DashboardCards";
import WeatherCard from "../components/WeatherCard";
import ProgressTracker from "../components/ProgressTracker";
import AIRecommendationCard from "../components/AIRecommendationCard";
import PhotoReminderCard from "../components/PhotoReminderCard";

function Dashboard() {
  const [dashboard, setDashboard] = useState(null);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const res = await API.get("/dashboard/summary");
      setDashboard(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="dashboard-layout">
      <Sidebar />

      <div className="main-content">
        <div className="container-fluid">
          <h2 className="mb-4">
            🌱 Vermicompost Dashboard
          </h2>

          <DashboardCards dashboard={dashboard} />

          <div className="row mt-4 g-4">
            <div className="col-md-6">
              <WeatherCard />
            </div>

            <div className="col-md-6">
              <ProgressTracker dashboard={dashboard} />
            </div>

            <div className="col-md-6">
              <AIRecommendationCard />
            </div>

            <div className="col-md-6">
              <PhotoReminderCard />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;